import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { dict, JABATAN } from "./dict";

export const LANGS = [
  { code: "id", label: "Bahasa Indonesia", short: "ID" },
  { code: "en", label: "English", short: "EN" },
];

const KEY = "meranggi_lang";
const MANUAL = "meranggi_lang_manual";
const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    return dict[saved] ? saved : "id";
  });

  // Manual switch from the language menu — remembered on this device forever.
  const setLang = useCallback((l) => {
    if (!dict[l]) return;
    setLangState(l);
    localStorage.setItem(KEY, l);
    localStorage.setItem(MANUAL, "1");
  }, []);

  // Apply the logged-in user's default language, unless they already chose one manually.
  const applyUserDefault = useCallback((code) => {
    if (!dict[code]) return;
    if (localStorage.getItem(MANUAL) === "1") return;
    setLangState(code);
  }, []);

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const t = useCallback((key, vars) => {
    const table = dict[lang] || dict.id;
    let s = table[key] ?? dict.id[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
    return s;
  }, [lang]);

  const months = useMemo(() => (dict[lang] || dict.id)["_months"], [lang]);

  const value = useMemo(() => ({ lang, setLang, applyUserDefault, t, months }),
    [lang, setLang, applyUserDefault, t, months]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useT() {
  const c = useContext(Ctx);
  if (!c) throw new Error("useT must be used within LanguageProvider");
  return c;
}

export function translateJabatan(lang, val) {
  const m = JABATAN[val];
  return m ? (m[lang] || val) : (val || "");
}
